import type { ModelInfo } from '../../../../model/model-info';

/** Returns true when a ModelInfo entry should have a 3D model loaded. */
export const shouldRenderApplianceModel = (
	info: ModelInfo,
	noModelSkus: Array<string>
): boolean => {
	if (noModelSkus.includes(info.sku)) return false;
	const placeholderSku = (info as any).placeholderModelSku as string | null | undefined;
	if (info.sku === 'CUSTOM' && !placeholderSku) return false;
	return true;
};
